import imgPrimario from "../../assets/images/2.jpg";
import imgSecundario from "../../assets/images/secundario1.jpg";
import { Container, Carousel } from "react-bootstrap";

function FiestasDeLasArtes() {
  return (
    <Container className="py-4 text-center">
      <p className="text-center display-6 mb-4" style={{ letterSpacing: "2px" }} >
        Fiestas de las artes
      </p>

      <Carousel interval={3000} indicators controls fade>
        <Carousel.Item>
          <img src={imgPrimario} className="d-block mx-auto" style={{ width: "30%" }} alt="Slide 1"/>
        </Carousel.Item>

        <Carousel.Item>
          <img src={imgSecundario} className="d-block mx-auto" style={{ width: "30%" }} alt="Slide 2"/>
        </Carousel.Item>

        <Carousel.Item>
          <img src={imgPrimario} className="d-block mx-auto" style={{ width: "30%" }} alt="Slide 3" />
        </Carousel.Item>
      </Carousel>
    </Container>
  );
}

export default FiestasDeLasArtes;
